import { connect } from "react-redux";
import PersonalInformationForm from "./personalInformationForm";

const mapStateToProps = (state) => {
  const { personalInfoForm } = state.entities.userConfig;
  return { personalInfoForm };
};

export default connect(mapStateToProps)(PersonalInformationForm);
